// components/TopRefresh.tsx
"use client";
import { useState, useEffect } from "react";
import Lottie from "react-lottie-player"
import loadingJson from "@/public/media/load_data.json"

export default function TopRefresh() {
    const [pulling, setPulling] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let startY = 0;
        let isPulling = false;

        const handleTouchStart = (e: TouchEvent) => {
            if (window.scrollY === 0) {
                startY = e.touches[0].clientY;
                isPulling = true;
            } else {
                isPulling = false;
            }
        };

        const handleTouchMove = (e: TouchEvent) => {
            if (!isPulling) return;
            const currentY = e.touches[0].clientY;
            const diff = currentY - startY;

            if (diff > 20 && diff < 70) {
                setPulling(true); 
            }
            if (diff >= 300) {
                setPulling(false);
                setLoading(true);
                const body = document.body;
                body.style.position = "fixed";
                body.style.width = "100%";

                // 새로고침 트리거
                setTimeout(() => {
                    location.reload();
                }, 400);
            }
        };

        const handleTouchEnd = () => {
            setPulling(false);
        };

        window.addEventListener("touchstart", handleTouchStart);
        window.addEventListener("touchmove", handleTouchMove);
        window.addEventListener("touchend", handleTouchEnd);

        return () => {
            window.removeEventListener("touchstart", handleTouchStart);
            window.removeEventListener("touchmove", handleTouchMove);
            window.removeEventListener("touchend", handleTouchEnd);
        };
    }, []);

    return (
        <>
        {loading  &&
            <div className={`top-refresh ${pulling ? "show" : ""} ${loading ? "loading" : ""}`}>
                <div className="loadImg">
                    <Lottie loop animationData={loadingJson} play style={{ maxWidth: `400px`, margin: "0 auto" }} />
                </div>
            </div>
        }
        </>
    );
}
